import axios from "axios";
import { useState, useEffect } from "react";

const Blogs = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPost, setSelectedPost] = useState(null);
  const [postLoading, setPostLoading] = useState(false);

  useEffect(() => {
    axios
      .get("https://akcoda.in/blogs/wp-json/wp/v2/posts")
      .then((response) => {
        setPosts(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching WordPress posts:", error);
        setLoading(false);
      });
  }, []);

  const handlePostClick = async (id) => {
    setPostLoading(true);
    try {
      const response = await axios.get(`https://akcoda.in/blogs/wp-json/wp/v2/posts/${id}`);
      setSelectedPost(response.data);
    } catch (error) {
      console.error("Error fetching post by ID:", error);
    } finally {
      setPostLoading(false);
    }
  };

  return (
    <div className="container p-5">
      <h1 className="mb-4" style={{color:'#3e13c0ff', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>Latest Blog Posts</h1>

      {/* Show full blog post if selected */}
      {selectedPost ? (
        <div className="mb-5">
          <button className="btn btn-secondary mb-3" onClick={() => setSelectedPost(null)}>
            ← Back to all posts
          </button>
          {postLoading ? (
            <p>Loading full post...</p>
          ) : (
            <div className="blog-full">
              <h2 dangerouslySetInnerHTML={{ __html: selectedPost.title.rendered }} />
              <div dangerouslySetInnerHTML={{ __html: selectedPost.content.rendered }} />
            </div>
          )}
        </div>
      ) : loading ? (
        <p>Loading...</p>
      ) : (
        <div className="blog-grid">
          {posts.map((post) => (
            <div
              key={post.id}
              className="blog-card"
              onClick={() => handlePostClick(post.id)}
              style={{ cursor: "pointer" }}
            >
              <h3 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
              <div dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Blogs;
